import { render, staticRenderFns } from "./ItemsRecommend.vue?vue&type=template&id=029a7c0c&scoped=true"
import script from "./ItemsRecommend.vue?vue&type=script&lang=js"
export * from "./ItemsRecommend.vue?vue&type=script&lang=js"
import style0 from "./ItemsRecommend.vue?vue&type=style&index=0&id=029a7c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029a7c0c",
  null
  
)

export default component.exports